module.exports = __webpack_public_path__ + "img/GAME_PICTURELOTUS1.1ed322f6.jpg";